import { render, staticRenderFns } from "./barrainferior.vue?vue&type=template&id=7b3637a8&scoped=true&"
import script from "./barrainferior.vue?vue&type=script&lang=ts&"
export * from "./barrainferior.vue?vue&type=script&lang=ts&"
import style0 from "./barrainferior.vue?vue&type=style&index=0&id=7b3637a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3637a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
